import { createI18n } from "vue-i18n";
import { getTranslations, QFood } from "@q-food/q-food";

const i18n = createI18n({
	/**
	 * Composition mode. Legacy mode installs a global mixin whose `unmounted` hook dereferences
	 * `this.$i18n` without a null check (vue-i18n.mjs:1591 vs :1613), which throws
	 * "can't access property __disposer, _vueI18n is undefined" whenever a component is torn down
	 * without it — constantly during HMR. That mixin is only installed for the legacy API.
	 *
	 * `globalInjection` keeps `$t` and `$n` available in templates, which is all this app uses of the
	 * global helpers; composition mode exposes t, rt, d, n, tm and te.
	 */
	legacy: false,
	globalInjection: true,
	locale: "nl",
	messages: {},
});

QFood.BASE_URL = `${window.location.protocol}//${window.location.host}`;

/**
 * Load a language's messages into vue-i18n and make it the active locale.
 *
 * Backend note: `/translations` returns whichever language the signed-in user has active and IGNORES the
 * code it is given (it reads the active language from the session). So `localeCode` here is used purely
 * client-side — as the vue-i18n slot the messages are stored under and the locale we switch to. We pass
 * the real language code (not a fixed "nl") so the locale reflects the actual language and so `$n`/`$d`
 * number/date formatting stays valid. Call this after `setActiveLanguage(code)` to swap the whole app to
 * `code` in place, without a page reload.
 */
function loadTranslations(localeCode: string) {
	return getTranslations(localeCode).then((translations) => {
		i18n.global.setLocaleMessage(localeCode, translations);
		i18n.global.locale.value = localeCode;
	});
}

function translate(key: string, args: Array<string> = []) {
	return i18n.global.t(key, args);
}

export { i18n, translate, loadTranslations };
export default i18n;
